
const base_url = "/api/users";

export const submitLogin = (credentials) => {
    return fetch(`${base_url}/local-login`, {
        headers: {
            "Content-Type": "application/json"
        },
        method: "POST",
        body: JSON.stringify(credentials)
    }).then(results => {
        if(results.ok) {
            return results.json();
        }

        return Promise.reject(results.json())
    });
}


export const submitRegistration = (data) => {
    return fetch(`${base_url}/register`, {
        headers: {
            "Content-Type": "application/json"
        },
        method: "POST",
        body: JSON.stringify(data)
    }).then(results => {
        if(results.ok) {
            return Promise.resolve({});
        }

        return Promise.reject(results.json())
    });
}



export const getUserProfile = (token) => {
    // eslint-disable-next-line no-console
    return fetch(`${base_url}/current-profile`, {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        }
    }).then(results => {
        if(results.ok) {
            return results.json();
        }

        return Promise.reject(results.json())
    });

}

export const submitPasswordReset = (resetData) => {
    return fetch(`${base_url}/reset-password`, {
        headers: {
            "Content-Type": "application/json"
        },
        method: "POST",
        body: JSON.stringify(resetData)
    }).then(results => {
        if(results.ok) {
            return results.json();
        }

        return Promise.reject(results.json())
    });
}

export const submitChangePassword = (changePasswordData) => {
    return fetch(`${base_url}/change-password`, {
        headers: {
            "Content-Type": "application/json"
        },
        method: "POST",
        body: JSON.stringify(changePasswordData)
    }).then(results => {
        if(results.ok) {
            return results.json();
        }

        return Promise.reject(results.json())
    });
}
